
            const data = {"name":"add3","data":{"width":"64","height":"64","viewBox":"0 0 64 64","data":"<circle pid=\"0\" cx=\"32\" cy=\"32\" r=\"32\" _fill=\"#2B9E7C\"/><path pid=\"1\" d=\"M32.194 43.898h3.109v-9.964h9.964v-3.091h-9.964v-9.964h-3.11v9.964H22.23v3.09h9.964v9.965Z\" _fill=\"#fff\"/>","originalColors":[{"type":"fill","color":"#2B9E7C"},{"type":"fill","color":"#fff"}],"stopColors":[]}}
        
                    module.exports = data
                    